import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Breadcrumbs for deeper informational pages (comparison, updates, resources).
 *
 * Added for the audit's orphan/internal-link findings and for plain usability:
 * a visitor arriving from search can see where the page sits and climb back up.
 * Rendered as a semantic <nav><ol> with a real link home, and the current page
 * marked with aria-current rather than linked to itself.
 */
export default function Breadcrumbs({ items, testId = "breadcrumbs" }) {
  if (!items || !items.length) return null;
  return (
    <nav aria-label="Breadcrumb" data-testid={testId}>
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-[#7A868B]">
        <li>
          <Link
            to="/"
            className="font-medium text-[#1F6F78] hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1F6F78]"
          >
            Home
          </Link>
        </li>
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <li key={item.label} className="flex items-center gap-1.5">
              <ChevronRight className="w-3.5 h-3.5" aria-hidden="true" />
              {last || !item.to ? (
                <span aria-current={last ? "page" : undefined} className="text-[#4B5A60]">
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.to}
                  className="font-medium text-[#1F6F78] hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1F6F78]"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
